import { ActionContext } from 'vuex'
import apiLayermap from '@/api/layermap'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { ILayermapState } from '@/store/modules/layermap/state'
import WKT from 'ol/format/WKT'
import * as sphere from 'ol/sphere'
import { Feature } from 'ol'
import { DepthProfile } from '@/models/ui/DepthProfile'

export class LayermapAction {
      
  public [types.LAYERMAP_DEPTH_PROFILE_REQUEST](context: ActionContext<ILayermapState, IRootState>,feature:Feature) {
    return new Promise((resolve, reject) => {
      context.commit(types.LAYERMAP_DEPTH_PROFILE_REQUEST)

      //construction du format wkt du line string
      let format =  new WKT()
      const lineStringGeo = format.writeFeature(feature,{ dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'})      
      //format.writeFeatureText(feature,{ dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'})      
      //todo test extent du feature pour voir si il est dans la zone couverte par emodnet sinon utiliser l'autre provider
      context.commit(types.LAYERMAP_DEPTH_PROFILE_PROVIDER,'Emodnet')      

      apiLayermap.getEmodnetDepthProfile(lineStringGeo)
        .then(({data}) => {             
          const depthProfile = new DepthProfile({
            //@ts-ignore
            extent:feature.getGeometry().getExtent(),     
            distance:Math.round((sphere as any).getLength(feature.getGeometry())),
            depths:data
          })
          context.commit(types.LAYERMAP_DEPTH_PROFILE_SUCCESS, depthProfile)
          resolve(depthProfile)
        })
        .catch(resp => {
          context.commit(types.LAYERMAP_DEPTH_PROFILE_ERROR)
          reject()
        })
    });
  }

  
}

export default util.classToObject(LayermapAction)